import { render, staticRenderFns } from "./ConFirmQuickPayment.vue?vue&type=template&id=bf773fc2"
import script from "./ConFirmQuickPayment.vue?vue&type=script&lang=js"
export * from "./ConFirmQuickPayment.vue?vue&type=script&lang=js"
import style0 from "./ConFirmQuickPayment.vue?vue&type=style&index=0&id=bf773fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports